import { IconKey } from 'koddi-components/Icon';
import {
    DetailedHTMLProps,
    Dispatch,
    InputHTMLAttributes,
    MouseEventHandler,
    MutableRefObject,
    ReactElement,
    ReactNode,
    Ref,
    SetStateAction,
} from 'react';
import { FieldRenderProps, FieldProps } from 'react-final-form';

export type BaseHTMLInputProps = DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
>;

type BaseInputProps = {
    label?: string;
    text?: string;
    name: string;
    fullWidth?: boolean;
    flexDirection?: string;
    forwardedRef?:
        | ((instance: HTMLInputElement | null) => void)
        | MutableRefObject<HTMLInputElement | null>
        | null;
    outerRef?: Ref<HTMLDivElement>;
    inputContainerRef?: Ref<HTMLDivElement>;
    iconRight?: ReactNode;
    iconLeft?: IconKey;
    useAriaLabel?: boolean;
    hasError?: boolean;
    errorText?: string;
    labelToolTip?: boolean;
    toolTipText?: string;
    /**
     * Flag to control +/- icons from being displayed on number input
     */
    hideIcons?: boolean;
    onContainerClick?: MouseEventHandler<HTMLDivElement>;

    /**
     * Enables content (like units) to be displayed to the right of the input box
     */
    unitLabelContent?: ReactElement;

    /**
     * Force the element to have a border of exactly some measurement
     */
    fixedBorderWidth?: string;

    /**
     * Set how wide the entire input element will be
     */
    fieldWidth?: string;

    /**
     * Set the height of the element
     */
    height?: string;
    maxHeight?: string;

    paddingLeft?: string;
    borderRadius?: string;
    /** Word count separated by the given separator */
    hasWordCount?: boolean;
    maxAmountOfWords?: number;
    wordCountSeparator?: string;
    setExceededWordCount?: Dispatch<SetStateAction<boolean>>;
    maxWordLength?: number;
    setExceededWordLength?: Dispatch<SetStateAction<boolean>>;
};

export type InputProps = BaseInputProps &
    Partial<FieldRenderProps<string, HTMLInputElement>> &
    Omit<BaseHTMLInputProps, 'name'>;

export type InputFieldComponentProps = BaseInputProps & {
    input: FieldRenderProps<string, HTMLInputElement>['input'];
    meta: FieldRenderProps<string, HTMLInputElement>['meta'];
} & Omit<BaseHTMLInputProps, 'name'>;

export type InputFieldProps = BaseInputProps &
    Omit<
        FieldProps<string, InputFieldComponentProps, HTMLInputElement>,
        'component'
    >;

export type StyledInputProps = {
    hasError?: boolean;
    readOnly?: boolean;
    disabled?: boolean;
    minWidth?: string;
    minHeight?: string;
    customChevronIconMargin?: boolean;
    ref?: any;
    v2?: boolean;
    maxLength?: number;
    hasCharacterCount?: boolean;
    fixedBorderWidth?: string;
    fieldWidth?: string;
    height?: string;
    maxHeight?: string;
    paddingLeft?: string;
    borderRadius?: string;
};

export type StyledInputInnerProps = Omit<StyledInputProps, 'ref'>;

export enum AutoCompleteValues {
    NewPassword = 'new-password',
    NewPhone = 'new-phone',
    Off = 'off',
    On = 'on',
}
